import React from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { Row, GraphAutoComplete, PortalButton, FormElements, Grid, Spinner } from '@custom-components';
import { ADMIN_SEARCH_PROPERTIES } from '@containers/AutoCompleteContainer/gql';

function Initiate(props) {
  const {
    stepId,
    mainForm,
    selectedOption,
    searchInput,
    data,
    loading,
    handleChangeOption,
    handleValueSearchForm,
    handleSearchInput,
    handleSelectedDetail,
    handleSetStep
  } = props;

  const nextStep = parseInt(stepId, 10) + 1;

  const handleGetDetails = (formDetails, { values }, step, option) => {
    handleSelectedDetail(formDetails, values);
    handleSetStep(step, option);
  };

  const loadGraphAutoComplete = (searchForm) => {
    switch (selectedOption[0].toLowerCase()) {
      /*
        This part is commented because it will be necessary to implement
        a resolver on API and add a AdminQuery on Data to use TYPEAHEAD
        for other Entities, otherwise it will give POST 400 error
      */

      // Property
      default:
        return (
          <GraphAutoComplete
            name="searchInput"
            value={handleValueSearchForm(searchForm)}
            label={selectedOption[stepId]}
            setFieldValue={searchForm.setFieldValue}
            graphql={{
              accessString: 'AdminQueries.propertyTypeahead',
              query: ADMIN_SEARCH_PROPERTIES,
              mapper: (dataMapper) =>
                dataMapper.map((item) => ({
                  label: item.name,
                  value: item.id.toString()
                })),
              variables: (value) => ({ propertyName: value.query })
            }}
            variant="standard"
            error={!!searchForm.errors.searchInput && searchForm.submitCount > 0}
            errorText={searchForm.errors.searchInput ? searchForm.errors.searchInput.value : ''}
            required
          />
        );
    }
  };

  return (
    <>
      {loading ? (
        <div style={{ justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
          <Spinner size={22} />
        </div>
      ) : (
        <>
          <Row style={{ marginTop: '5%' }}>
            <Grid.Col lg={12}>
              <FormElements.Select
                variant="outlined"
                id="requestConnection"
                key="requestConnection"
                name="requestConnection"
                label="Select Request"
                value={mainForm.values.requestConnection}
                options={data}
                onBlur={mainForm.handleBlur}
                onChange={(item) => handleChangeOption(mainForm, item, data)}
                error={!!mainForm.errors.requestConnection}
                errorText={mainForm.errors.requestConnection}
                inputProps={{ readOnly: true }}
              />
            </Grid.Col>
          </Row>
          {selectedOption[stepId] && selectedOption[stepId].length > 0 && (
            <Row style={{ marginTop: '3%' }}>
              <Grid.Col lg={12}>
                <Formik initialValues={searchInput} onSubmit={handleSearchInput}>
                  {(searchForm) => (
                    <>
                      {loadGraphAutoComplete(searchForm)}
                      <Row style={{ marginTop: '3%' }}>
                        <Grid.Col md={8}>
                          <PortalButton
                            onClick={() => handleGetDetails(mainForm, searchForm, nextStep, selectedOption[0])}
                            disabled={
                              !Object.prototype.hasOwnProperty.call(searchForm.values, 'searchInput') ||
                              (Object.prototype.hasOwnProperty.call(searchForm.values, 'searchInput') &&
                                Object.keys(searchForm.values.searchInput.value).length <= 0)
                            }
                          >
                            Get {selectedOption[stepId]} Details
                          </PortalButton>
                        </Grid.Col>
                      </Row>
                    </>
                  )}
                </Formik>
              </Grid.Col>
            </Row>
          )}
        </>
      )}
    </>
  );
}

Initiate.propTypes = {
  stepId: PropTypes.number,
  mainForm: PropTypes.shape({
    values: {
      requestConnection: PropTypes.string
    },
    errors: {
      requestConnection: PropTypes.string
    },
    handleBlur: PropTypes.func
  }),
  selectedOption: PropTypes.arrayOf(PropTypes.string),
  searchInput: PropTypes.shape({}),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  handleChangeOption: PropTypes.func,
  handleValueSearchForm: PropTypes.func,
  handleSearchInput: PropTypes.func,
  handleSelectedDetail: PropTypes.func,
  handleSetStep: PropTypes.func
};

Initiate.defaultProps = {
  stepId: 0,
  mainForm: {},
  selectedOption: [],
  searchInput: {},
  data: [],
  loading: false,
  error: {},
  handleChangeOption: () => {},
  handleValueSearchForm: () => {},
  handleSearchInput: () => {},
  handleSelectedDetail: () => {},
  handleSetStep: () => {}
};

export default Initiate;
